"use client";

import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ShortcutHelp() {
  const { t } = useTranslation("ui");

  const SHORTCUTS = [
    { section: t("shortcutHelp.sections.navigation"), items: [
      { key: "J", description: t("shortcutHelp.items.selectNext") },
      { key: "K", description: t("shortcutHelp.items.selectPrev") },
      { key: "Enter", description: t("shortcutHelp.items.openDetail") },
      { key: "Esc", description: t("shortcutHelp.items.closePanel") },
      { key: "← →", description: t("shortcutHelp.items.navigatePanel") },
    ]},
    { section: t("shortcutHelp.sections.actions"), items: [
      { key: "A", description: t("shortcutHelp.items.approvePiece") },
      { key: "R", description: t("shortcutHelp.items.rejectPiece") },
      { key: "E", description: t("shortcutHelp.items.editCopy") },
    ]},
    { section: t("shortcutHelp.sections.general"), items: [
      { key: "?", description: t("shortcutHelp.items.showHelp") },
    ]},
  ];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 w-7 fixed bottom-4 right-4 z-50 opacity-50 hover:opacity-100">
          <HelpCircle size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t("shortcutHelp.title")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {SHORTCUTS.map((section) => (
            <div key={section.section}>
              <h4 className="mb-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
                {section.section}
              </h4>
              <div className="space-y-1">
                {section.items.map((item) => (
                  <div key={item.key} className="flex items-center justify-between">
                    <span className="text-sm">{item.description}</span>
                    <kbd className="rounded bg-muted px-2 py-0.5 text-xs font-mono">{item.key}</kbd>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
